import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import CurrencyAmount from '../../canopy-ui-components/components/CanopyTable/Cells/CurrencyAmount';
import ErrorBox from '../../canopy-ui-components/components/ErrorBox/ErrorBox';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';

const CustomHoldingsPager = ({
    visibleColumns,
    globalProps,
    totals,
    page,
}: Record<string, any>) => {
    const currentColors = useCurrentColors();
    const { t } = useTranslation();
    const showBorder = true;
    if (!page?.[0]) {
        return (
            <ErrorBox
                position="relative"
                boxShadow={`0px 0px 2px ${currentColors.boxShadow}`}
                height="35vh"
                borderRadius="4px"
                rounded="md"
                error={t('no-data-available')}
            />
        );
    }
    return (
        <Box
            borderLeft={
                showBorder
                    ? `1px solid ${currentColors.componentBorder}`
                    : '0px'
            }
            borderRight={
                showBorder
                    ? `1px solid ${currentColors.componentBorder}`
                    : '0px'
            }
            backgroundColor={
                page?.[0]?.depth === 0 ? currentColors.primaryColor : undefined
            }
            _last={{
                borderBottom: `1px solid ${currentColors.componentBorder}`,
            }}
            height="40px"
            _after={
                page?.[0]?.depth === 0 && page?.[0]?.index !== 0
                    ? {
                          borderBottom: `1px solid ${currentColors.tableRowBorder}`,
                          content: "''",
                          left: '20px',
                          position: 'absolute',
                          width: 'calc(100% - 40px)',
                      }
                    : page?.[0]?.depth !== 0
                    ? {
                          borderBottom: `1px solid ${currentColors.subTableRowBorder}`,
                          content: "''",
                          left: '20px',
                          position: 'absolute',
                          width: 'calc(100% - 40px)',
                      }
                    : undefined
            }
            {...page?.[0]?.getRowProps()}>
            {visibleColumns.map((column: any, index: number) => {
                const columnDef = visibleColumns.filter(
                    (item: any) => item.id === column.id
                )[0];
                const width = columnDef?.width;
                const isAction = column.id === 'actions';
                let align = 'flex-start';
                if (isAction || columnDef?.align === 'right') {
                    align = 'flex-end';
                } else if (columnDef?.align === 'center') {
                    align = 'center';
                }
                if (column.id === 'security_name') {
                    return (
                        <Box
                            role="cell"
                            color="white"
                            width={
                                columnDef?.width ? columnDef?.width : '200px'
                            }
                            className={`td ${
                                columnDef?.canReorder ? 'td-reorder' : ''
                            }`}
                            lineHeight="1"
                            display="flex"
                            alignItems="center"
                            key={column.id}
                            justifyContent={column.align}
                            fontWeight="bold"
                            background={currentColors.primaryColor}
                            {...page?.[0]?.cells[index].getCellProps()}>
                            {globalProps.t('total')?.toUpperCase()}
                        </Box>
                    );
                } else {
                    return (
                        <Box
                            role="cell"
                            color="white"
                            width={
                                columnDef?.width ? columnDef?.width : '200px'
                            }
                            className={`td ${
                                columnDef?.canReorder ? 'td-reorder' : ''
                            }`}
                            py={
                                page?.[0]?.cells[index]?.depth === 0
                                    ? '10px'
                                    : '5px'
                            }
                            lineHeight="1"
                            display="flex"
                            alignItems="center"
                            justifyContent={align}
                            {...page?.[0]?.cells[index].getCellProps()}
                            key={column.id}>
                            <CurrencyAmount
                                fontSize="13px"
                                fontWeigth="bold"
                                amount={totals[column.id]}
                                currency={
                                    column.id !== 'percent_of_assets'
                                        ? 'USD'
                                        : ''
                                }></CurrencyAmount>
                        </Box>
                    );
                }
            })}
        </Box>
    );
};

export default CustomHoldingsPager;
